﻿import { MaterialService } from '@kb3d/models/services';
import { Enumerable, Inject } from '../decorators';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { IDisplacementMapFeature } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { TextureLayer } from '../materials';
import { Token } from '../token';
import { ALL_GEOMETRY, eMeshChangeTypes, Feature, FeatureWithTextures } from './feature';

@Kb3dModel({
    token: Token.DisplacementMapFeature,
})
export class DisplacementMapFeature extends Feature implements IDisplacementMapFeature, FeatureWithTextures {
    static _affects = new Set([eMeshChangeTypes.VertexNormals, eMeshChangeTypes.VertexPositions]);
    static _affectedBy = new Set(ALL_GEOMETRY);
    private _textures: TextureLayer[];
    constructor() {
        super();

        this._initialized = false;
    }

    @Enumerable()
    public get textures(): TextureLayer[] {
        if (!this._textures) this._textures = [];
        return this._textures;
    }
    public set textures(val) {
        this._textures = val;
    }

    minDisplacement: number;
    maxDisplacement: number;
    _initialized: boolean;

    public getChildren(): Kb3dObject[] {
        return [...this.textures];
    }

    public getChildArrayForType(token: Token): Kb3dObject[] | undefined {
        if (token.isTexture()) {
            return this.textures;
        } else {
            throw 'unexpected token';
        }
    }
}
